import Header from "components/Headers/Header";
import SeasonalBadgeAddModal from "components/SeasonalBadgeAddModal";
import SeasonalEditModal from "components/SeasonalEditModal";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Container,
  Row,
  Spinner,
  Col,
  Modal,
  Label,
  Input,
  FormGroup,
  Form,
  ModalBody
} from "reactstrap";
import { deleteBadge, getSeasonalBadges } from "store/actions/SeasonActions";
import ImageSlider from "components/ImageSlider";
import ReuseableTable from "components/Tables/ReuseableTable";
import WelcomeScreen from "components/WelcomeScreen";
import seosonalBadgeWelcomeImage from "../../assets/img/custom/seosonal_preview_badge.png";
import { Rating } from "@mui/material";
import { updateRatingData } from "store/actions/SeasonActions";
import { toast } from "react-toastify";
import { addStrategyRating } from "store/actions/SeasonActions";
import firebase from "../../config/firebase";

const SeasonalBadges = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { athleteBadges, SeosonallastDocument, SeosonalhasMoreDocument } =
    useSelector((state) => state.season);
  const [addModal, setAddModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [strategyRating, setStrategyRating] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [objToEdit, setObjToEdit] = useState(null);
  const [modal1, setModal1] = useState(false);
  const [handleContinue, setHandleContinue] = useState(false);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [docId, setDocId] = useState("");
  const [ratingModal, setRatingModal] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [selectedStrategyRating, setSelectedStrategyRating] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [remarks, setRemarks] = useState("");
  const [strategyRemarks, setStrategyRemarks] = useState("");
  const [ratingBtnLoader, setRatingBtnLoader] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [managerEmail, setManagerEmail] = useState("");
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };
  const toggleRatingModal = () => {
    setRatingModal(!ratingModal);
    setSelectedRating(0);
    setSelectedStrategyRating(0);
    setSelectedOption("");
    setRemarks("");
    setStrategyRemarks("");
    setStrategyRating(false);
  };
  const Modaltoggle1 = () => setModal1(!modal1);

  const columns = ["#", "SPORT", "SEASON", "ONLINE PRICE", "QR CODE PRICE"];

  const keyMap = {
    "#": "tag",
    SPORT: "sport",
    SEASON: "season",
    "ONLINE PRICE": "onlinePrice",
    "QR CODE PRICE": "qrCodePrice"
  };

  const handleLoadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getSeasonalBadges(user?.athleteID, SeosonallastDocument, () => {
        setLoadMoreLoader(false);
      })
    );
  };
  const handleRatingSubmit = (e) => {
    e.preventDefault();
    const ratingData = {
      rating: selectedRating,
      satisfactory: selectedOption,
      remarks: remarks,
      managerRating: true
    };
    if (selectedRating == "") {
      toast.warning("Please Add Rating");
    } else if (selectedOption == "") {
      toast.warning("Please Give Review Satisfied Or Unsatisfied");
    } else {
      setRatingBtnLoader(true);
      dispatch(
        updateRatingData(ratingData, docId, () => {
          if (strategyRating) {
            dispatch(
              addStrategyRating({
                athleteName: user.first_name + " " + user.last_name,
                athleteId: user.athleteID,
                athleteEmail: user.email,
                strategyRating: selectedStrategyRating,
                strategyRemarks: strategyRemarks,
                managerEmail: managerEmail,
                docId: docId,
                createdAt: firebase.firestore.Timestamp.now()
              })
            );
          }
          setRatingBtnLoader(false);
          toast.success("Add Manager Rating Successfully");
          toggleRatingModal();
          setSelectedRating(0);
          setSelectedStrategyRating(0);
          setSelectedOption("");
          setRemarks("");
          setStrategyRemarks("");
        })
      );
    }
  };

  const toggle = () => {
    setAddModal(!addModal);
    setModal1(false);
  };
  const editToggle = () => {
    if (editModal) {
      setObjToEdit(null);
    }
    setEditModal(!editModal);
  };

  const deleteSeasonalBadge = () => {
    setDeleteLoader(true);
    dispatch(
      deleteBadge(user?.id, docId, () => {
        dispatch(
          getSeasonalBadges(user?.athleteID, "", () => {
            setDeleteLoader(false);
            toggleDeleteModal();
          })
        );
      })
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderActions = (item) => {
    return (
      <Row>
        <Button
          size="sm"
          color="primary"
          className="px-3 m-1"
          onClick={() => {
            setObjToEdit({
              ...item,
              onlinePrice: item.onlinePrice
                ? parseFloat(item.onlinePrice.replace("$", ""))
                : "",
              qrCodePrice: item.qrCodePrice
                ? parseFloat(item.qrCodePrice.replace("$", ""))
                : ""
            });
            editToggle();
          }}
        >
          Edit
        </Button>
        <Button
          size="sm"
          color="danger m-1"
          onClick={() => {
            toggleDeleteModal();
            setDocId(item.id);
          }}
        >
          Delete
        </Button>
        {item.managerEmail ? (
          <Button
            size="sm"
            color="success"
            className="text-nowrap m-1"
            disabled={item.managerRating}
            onClick={() => {
              toggleRatingModal();
              setDocId(item.id);
              setManagerEmail(item.managerEmail);
            }}
          >
            Manager Rating
          </Button>
        ) : (
          ""
        )}
      </Row>
    );
  };

  const seosonalBadgesContent = () => {
    return (
      <>
        <div className="border border-dark">
          <h1
            className="font-weight-bolder text-center"
            style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
          >
            SEASONAL BADGES & VIEWS ATHLETE TIPS + WATCH VIDEO
          </h1>
        </div>
        <p className="font-weight-normal mt-2">
          <b className="text-danger">
            BE CREATIVE WHEN YOU RECORD VIDEOS TO LINK TO QR CODES&nbsp;
          </b>
          in your series of&nbsp;
          <b className="text-primary">SEASONAL BADGES&nbsp;</b>
          <b className="text-danger">
            & INSTANT ONLINE VIDEO VIEWS. FANS WILL BUY AND ENJOY.
          </b>
        </p>
        <p className="font-weight-normal mt-2">
          These &nbsp;
          <b className="text-dark ">
            SEASONALs at&nbsp;
            <b>
              <b className="text-dark">Fans</b>
              <b className="text-primary">Help</b>
              <b className="text-danger">Players</b>
            </b>{" "}
          </b>
          can be of two types. The first is an&nbsp;
          <b className="text-danger">ONLINE VIDEO made by a Student Athlete.</b>
          &nbsp;The second is a&nbsp;
          <b className="text-danger">CARD with QR</b>&nbsp; code you scan to see
          a&nbsp;
          <b className="text-danger">
            linked video of SPORTS ANALYSIS made by the
          </b>
          &nbsp; <b className="text-primary">Student Athlete of Your Choice.</b>
        </p>

        <p className="font-weight-normal mt-2">
          HERE’S another important thing to Remember– up to{" "}
          <b className="text-dark ">
            <b className="text-danger">88%</b> of the money spent at{" "}
            <b className="text-dark">F</b>
            <b className="text-primary">H</b>
            <b className="text-danger">P </b>
            <b className="text-dark">goes </b>
            <b className="text-danger">directly to Student Athletes.</b>
          </b>
        </p>
        <p className="font-weight-normal mt-2">
          <b className="text-dark">THANK YOU!</b>{" "}
          <u className="text-dark">Enjoy</u> and{" "}
          <b className="text-dark">
            <u>TELL YOUR FRIENDS.</u>
          </b>
        </p>
      </>
    );
  };
  const youtubeLink = "https://www.youtube.com/watch?v=iOAuhUd-om0​";

  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getSeasonalBadges(user?.athleteID, "", () => {
        setDataLoader(false);
      })
    );
  }, []);
  return (
    <>
      <Header />
      <Container fluid>
        {handleContinue ? (
          <>
            <h1
              className="text-center mb-3"
              style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
            >
              Seasonal Badges
            </h1>

            <h4 className="mx-2">
              NOTE: Videos in Seasonal Badges are prepared by registered
              athletes and their managers. Such compiling is within fair use
              guidelines by which sports highlight videos and commentary may
              achieve educational value.
            </h4>
            <Card className="p-3 mt-3">
              <Row className="justify-content-end px-4 mb-3">
                <Button
                  onClick={Modaltoggle1}
                  color="primary"
                  className="float-right"
                >
                  Create Badge
                </Button>
              </Row>
              {dataLoader ? (
                <Row className="justify-content-center py-5">
                  <Spinner size="md" color="primary" />
                </Row>
              ) : (
                <>
                  <ReuseableTable
                    columns={columns}
                    data={athleteBadges?.map((item) => ({
                      ...item,
                      tag:
                        item?.sportType.toUpperCase() +
                        " - " +
                        item?.listNumber,
                      sport: item?.sport,
                      season: item?.year,
                      onlinePrice: !item?.onlineUrlPrice
                        ? null
                        : `$${item?.onlineUrlPrice}`,
                      qrCodePrice: !item?.qrCodePrice
                        ? null
                        : `$${item?.qrCodePrice}`
                    }))}
                    keyMap={keyMap}
                    renderActions={renderActions}
                  />
                  <div className="w-100  p-3 d-flex justify-content-center">
                    {athleteBadges && athleteBadges?.length >= 5 && (
                      <Button
                        color="primary"
                        onClick={handleLoadMore}
                        disabled={!SeosonalhasMoreDocument || loadMoreLoader}
                      >
                        {loadMoreLoader ? <Spinner size={"sm"} /> : "Load More"}
                      </Button>
                    )}
                  </div>
                </>
              )}
            </Card>
          </>
        ) : (
          <Container>
            <Row>
              <WelcomeScreen
                setHandleContinue={setHandleContinue}
                content={seosonalBadgesContent}
                welcomeImage={seosonalBadgeWelcomeImage}
                youtubeLink={youtubeLink}
              />
            </Row>
          </Container>
        )}
      </Container>

      <SeasonalBadgeAddModal toggle={toggle} addModal={addModal} />
      <SeasonalEditModal
        toggle={editToggle}
        editModal={editModal}
        updateObj={objToEdit}
      />

      <Modal isOpen={modal1} toggle={Modaltoggle1} size="lg">
        <Container className="text-center ">
          <ImageSlider />
        </Container>
        <div className="d-flex justify-content-end align-items-end mb-2 mr-4">
          <Button color="primary" onClick={toggle}>
            Ok
          </Button>
        </div>
      </Modal>
      <Modal isOpen={ratingModal} toggle={toggleRatingModal} centered>
        <Form onSubmit={handleRatingSubmit}>
          <Container className="text-center p-5">
            <h4 className="mb-4">Rate this Badge</h4>
            <Row className="justify-content-center">
              <Rating
                value={selectedRating}
                onChange={(event, newValue) => {
                  setSelectedRating(newValue);
                }}
                stars={3}
              />
            </Row>
            <Row>
              <FormGroup>
                <Label for="radioButtons">Choose an option:</Label>
                <div>
                  <Col lg="4">
                    <Label check>
                      <Input
                        type="radio"
                        name="radioOptions"
                        value="Satisfied"
                        checked={selectedOption === "Satisfied"}
                        onChange={(e) => setSelectedOption(e.target.value)}
                      />
                      Satisfied
                    </Label>
                  </Col>
                  <Col lg="4">
                    <Label check>
                      <Input
                        type="radio"
                        name="radioOptions"
                        value="Unsatisfied"
                        checked={selectedOption === "Unsatisfied"}
                        onChange={(e) => setSelectedOption(e.target.value)}
                      />
                      Unsatisfied
                    </Label>
                  </Col>
                </div>
              </FormGroup>
            </Row>
            <FormGroup>
              <Label for="remarks">Remarks</Label>
              <Input
                required
                type="textarea"
                name="remarks"
                id="remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </FormGroup>
            <Row className="mt-0 mb-3">
              <Col>
                <Label>You want to give strategy Rating:</Label>
              </Col>
              <Col>
                <div>
                  <p className="edit-password-info">
                    <div className="switchBtnContainer">
                      <div
                        className="switchBtn"
                        style={{
                          backgroundColor: strategyRating
                            ? "#4caf50"
                            : "#f44336"
                        }}
                        onClick={() => setStrategyRating(!strategyRating)}
                      >
                        <div
                          className="switchBtnSlider"
                          style={{
                            left: strategyRating ? "26px" : "2px"
                          }}
                        ></div>
                      </div>
                      <span className="switchBtnLabel">
                        {strategyRating ? "Yes" : "No"}
                      </span>
                    </div>
                  </p>
                </div>
              </Col>
            </Row>
            {strategyRating && (
              <>
                <h4 className="mb-4">Strategy Rating For Manager</h4>
                <Row className="justify-content-center">
                  <Rating
                    value={selectedStrategyRating}
                    onChange={(event, newValue) => {
                      setSelectedStrategyRating(newValue);
                    }}
                    stars={3}
                  />
                </Row>
                <FormGroup>
                  <Label for="strategy-remarks">Strategy Remarks</Label>
                  <Input
                    required
                    type="textarea"
                    name="strategy-remarks"
                    id="strategy-remarks"
                    value={strategyRemarks}
                    onChange={(e) => setStrategyRemarks(e.target.value)}
                  />
                </FormGroup>
              </>
            )}
            <Button color="primary" type="submit" disabled={ratingBtnLoader}>
              {ratingBtnLoader ? <Spinner size="sm" /> : "Submit Rating"}
            </Button>
            <Button color="danger" onClick={toggleRatingModal}>
              Cancel
            </Button>
          </Container>
        </Form>
      </Modal>

      <Modal isOpen={deleteModal} centered toggle={toggleDeleteModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to Delete.
            </span>
            <br />
            <br />
            <br />
            <Button color="primary" onClick={toggleDeleteModal}>
              Cancel
            </Button>{" "}
            <Button color="danger" onClick={deleteSeasonalBadge}>
              {deleteLoader ? <Spinner size="sm" /> : "Delete"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SeasonalBadges;
